import { grey } from '@mui/material/colors';

export const responsiveBreakpoints = {
  xs: 0,
  sm: 600,
  md: 840,
  lg: 1200,
  xl: 1600,
  xxl: 1920,
};

export const themes = {
  light: {
    mode: 'light',
    primary: {
      main: '#00b398',
      contrastText: grey[100],
      dark: '#007864',
      light: '#34cbb2',
    },
    secondary: {
      main: '#009D83',
      contrastText: grey[100],
      dark: '#004d40',
      light: '#48a999',
    },
    background: {
      default: '#f8f9fa',
      paper: '#f5f5f5',
      common: '#fff',
    },
    text: {
      primary: '#000',
      info: '#757575',
    },
    error: {
      main: '#D32F2F',
    },
    warning: {
      main: '#ff9800',
    },
    neutral: {
      main: '#8695a7',
      grey: '#A9A9A9',
    },
    common: {
      white: '#fff',
      black: '#000',
      lightGrey: '#F2F2F2',
      greyBorder: '#D9D9D9',
      userCard: '#F5F5F5',
      stickyCell: '#EBEBEB',
      secondaryLight: '#F5F6FA',
      backgroundBox: '#FDFDFE',
    },
  },
  dark: {
    mode: 'dark',
    primary: {
      main: '#00b398',
      contrastText: grey[100],
      dark: '#007864',
      light: '#34cbb2',
    },
    secondary: {
      main: '#008F76',
      contrastText: grey[100],
      dark: '#007864',
      light: '#48a999',
    },
    background: {
      default: '#1E2A30',
      paper: '#1F2730',
      common: '#24333D',
    },
    text: {
      primary: '#fff',
      info: '#B0BEC5',
    },
    error: {
      main: '#EF5350',
    },
    warning: {
      main: '#E29E21',
    },
    neutral: {
      main: '#97A4AF',
      grey: '#f5f2f2',
    },
    common: {
      white: '#fff',
      black: '#000',
      lightGrey: '#394147',
      greyBorder: '#7C7C7C',
      userCard: '#2F4858',
      stickyCell: '#353C42',
      secondaryLight: '#23303A',
      backgroundBox: '#1E2A30',
    },
  },
};
